"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRepositionTxb = getRepositionTxb;
const tslib_1 = require("tslib");
const cetus_sui_clmm_sdk_1 = require("@cetusprotocol/cetus-sui-clmm-sdk");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
const transactions_1 = require("@mysten/sui/transactions");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
async function getRepositionTxb(poolName, adminCap) {
    const cetus_pool = (await (0, alphafi_sdk_1.getCetusPool)(poolName, true));
    const pool = cetus_pool?.content.fields;
    const curSqrtPrice = pool.current_sqrt_price;
    const cetusInvestor = (await (0, alphafi_sdk_1.getInvestor)(poolName, true));
    if (cetusInvestor && cetus_pool) {
        //TODO
        //check if you calculate lower_tick, upper_tick like this only
        const upper_bound = 443636;
        let lower_tick = Number(cetusInvestor.content.fields.lower_tick);
        let upper_tick = Number(cetusInvestor.content.fields.upper_tick);
        if (lower_tick > upper_bound) {
            lower_tick = -~(lower_tick - 1);
        }
        if (upper_tick > upper_bound) {
            upper_tick = -~(upper_tick - 1);
        }
        // AlphaFi Mascot
        //
        //      a
        //    ~~|~~
        //     / \
        //
        /////////////////
        const coinAName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
        const coinA = alphafi_sdk_1.coinsList[coinAName];
        const coinBName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
        const coinB = alphafi_sdk_1.coinsList[coinBName];
        const curPrice = cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToPrice(new bn_js_1.default(curSqrtPrice), coinA.expo, coinB.expo);
        const priceAtUpperTick = cetus_sui_clmm_sdk_1.TickMath.tickIndexToPrice(upper_tick, coinA.expo, coinB.expo);
        const priceAtNewUpperTick = curPrice.add(priceAtUpperTick.sub(curPrice).mul((0, cetus_sui_clmm_sdk_1.d)(30)));
        const newUpperTick = cetus_sui_clmm_sdk_1.TickMath.priceToInitializableTickIndex(priceAtNewUpperTick, coinA.expo, coinB.expo, Number(cetus_pool.content.fields.tick_spacing));
        const sqrtPriceAtNewUpperTick = cetus_sui_clmm_sdk_1.TickMath.tickIndexToPrice(newUpperTick, coinA.expo, coinB.expo);
        const sqrtPriceAtNewLowerTick = cetus_sui_clmm_sdk_1.MathUtil.fromX64(new bn_js_1.default(curSqrtPrice)).toNumber() +
            (cetus_sui_clmm_sdk_1.MathUtil.fromX64(new bn_js_1.default(curSqrtPrice)).toNumber() -
                sqrtPriceAtNewUpperTick.toNumber()) /
                (cetus_sui_clmm_sdk_1.MathUtil.fromX64(new bn_js_1.default(curSqrtPrice)).toNumber() *
                    sqrtPriceAtNewUpperTick.toNumber());
        const priceAtNewLowerTick = cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToPrice(cetus_sui_clmm_sdk_1.MathUtil.toX64((0, cetus_sui_clmm_sdk_1.d)(sqrtPriceAtNewLowerTick)), coinA.expo, coinB.expo);
        const newLowerTick = cetus_sui_clmm_sdk_1.TickMath.priceToInitializableTickIndex(priceAtNewLowerTick, coinA.expo, coinB.expo, Number(cetus_pool.content.fields.tick_spacing));
        const txb = new transactions_1.Transaction();
        if (coinBName == "SUI") {
            txb.moveCall({
                target: `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alpha_sui_investor::reposition`,
                typeArguments: [coinA.type, coinB.type],
                arguments: [
                    txb.object(alphafi_sdk_1.poolInfo[poolName].investorId),
                    txb.object(adminCap),
                    txb.object((0, alphafi_sdk_1.getConf)().VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_REWARDER_GLOBAL_VAULT_ID),
                    txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                    txb.pure.u64(newLowerTick),
                    txb.pure.u64(newUpperTick),
                    txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else {
            txb.moveCall({
                target: `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::cetus_investor::reposition`,
                typeArguments: [coinA.type, coinB.type],
                arguments: [
                    txb.object(alphafi_sdk_1.poolInfo[poolName].investorId),
                    txb.object(adminCap),
                    txb.object((0, alphafi_sdk_1.getConf)().VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_REWARDER_GLOBAL_VAULT_ID),
                    txb.object(alphafi_sdk_1.cetusPoolMap[`${coinBName}-SUI`]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                    txb.pure.u64(newLowerTick),
                    txb.pure.u64(newUpperTick),
                    txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        return txb;
    }
}
//# sourceMappingURL=reposition.js.map